<div class="content">
  <div class="grid">
    <div>
      <div class="headers">
        <app-date-filter-picker></app-date-filter-picker>
        <div style="padding-right: 100px">
          <span *ngIf="programArticles.length > 0" style="margin-right: 10px"
            >{{ programArticles.length }} programs found</span
          >
          <a
            md-raised-button
            [routerLink]="['/', { outlets: { modal: 'edit/filters' } }]"
            [color]="filtersTouchedByUser ? 'primary' : ''"
            style="margin-right: 10px"
          >
            <md-icon>filter_list</md-icon>
            Filters
          </a>
          <md-select
            placeholder="Default Tab"
            [(ngModel)]="destinationSelected"
            (change)="changeDestination()"
          >
            <md-option
              *ngFor="let destination of destinations"
              [value]="destination"
            >
              {{ destination.value }}
            </md-option>
          </md-select>
        </div>

        <div class="extract" *ngIf="destinations">
          <md-select placeholder="Extract" [(ngModel)]="destinationForExtract">
            <md-option
              *ngFor="let destination of destinations"
              [value]="destination"
            >
              {{ destination.value }}
            </md-option>
          </md-select>
          <button
            *ngIf="!extractLoading"
            md-raised-button
            color="primary"
            [disabled]="!destinationForExtract"
            (click)="extract('TXT')"
          >
            TXT
          </button>
          <button
            *ngIf="!extractLoading"
            md-raised-button
            color="accent"
            [disabled]="!destinationForExtract"
            (click)="extract('XML')"
          >
            XML
          </button>
          <button
            *ngIf="!extractLoading"
            md-raised-button
            color="warn"
            [disabled]="!destinationForExtract"
            (click)="extract('DOCX')"
          >
            DOCX
          </button>

          <app-spinner *ngIf="extractLoading"></app-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
<hr />
<app-spinner *ngIf="loading"></app-spinner>
<div class="wrapper">
  <div class="table-container">
    <div
      class="no-results"
      *ngIf="!loading && programArticles && programArticles.length === 0"
    >
      <md-icon>search</md-icon>
      <h3>No results</h3>
    </div>
    <table
      [md2Data]="programArticles"
      *ngIf="!loading && programArticles && programArticles.length > 0"
      class="program-articles"
      #md2="md2DataTable"
      [rowsPerPage]="100"
      [(activePage)]="activePage"
    >
      <thead>
        <tr>
          <th></th>
          <th md2SortBy="startDate">Time</th>
          <th md2SortBy="elementList">Sport / Type</th>
          <th md2SortBy="title">Title</th>
          <th md2SortBy="channel.value">Channel</th>
          <th md2SortBy="broadcasting.value">Broadcast</th>
          <th md2SortBy="lastUpdate">Options</th>
          <th md2SortBy="lastUpdate">Last edited</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let i of md2.data"
          class="row cursor-pointer"
          [ngClass]="{
            active:
              currentProgramArticle &&
              currentProgramArticle.valEmiId === i.valEmiId &&
              currentProgramArticle.channel.id === i.channel.id &&
              currentProgramArticle.cocoonId === i.cocoonId,
            camrelated:
              currentProgramArticle &&
              currentProgramArticle.valEmiId != i.valEmiId &&
              currentProgramArticle.channel.id !== i.channel.id &&
              currentProgramArticle.isSpevInMultiCamRelations(i.spev.id),
            current: i && i.isCurrent()
          }"
          (click)="setCurrentProgramArticle(i)"
        >
          <td>
            <img
              md-tooltip="Updated {{ i.getHoursDiff() }} hours ago"
              mdTooltipPosition="right"
              *ngIf="i.hasBeenUpdatedRecently()"
              class="png-icon"
              style="padding-left: 10px"
              src="../../../assets/img/bille2.gif"
            />
          </td>
          <td>
            {{ currentId }}
            <div>
              {{ i.startDate | date : "dd/MM HH:mm" }} -
              {{ i.endDate | date : "HH:mm" }}
            </div>
          </td>
          <td *ngIf="i.sport.value || i.type.value">{{ i.elementList }}</td>
          <td *ngIf="!i.sport.value && !i.type.value">
            <md-icon>warning</md-icon>
          </td>
          <td>{{ i.getTitle(destinationSelected) }}</td>
          <td>{{ i.channel.value }}</td>
          <td>{{ i.broadcasting.value }}</td>
          <td style="display: inline">
            <md-icon tooltip="Main" *ngIf="i.isMultiCam && i.isMain"
              >photo_camera</md-icon
            >
            <md-icon tooltip="Sub" *ngIf="i.isMultiCam && !i.isMain"
              >cameraswitch</md-icon
            >
            <img
              md-tooltip="BT"
              *ngIf="i.isBT"
              style="padding-left: 10px; height: 24px;"
              src="../../../assets/img/logo_bt.png"
            />
            <md-icon tooltip="Rescue - {{ i.rescueAction }}" *ngIf="i.isRescue">support</md-icon>
            <md-icon tooltip="Hidden" *ngIf="i.isHidden"
              >visibility_off</md-icon
            >
          </td>
          <td>
            {{ i.lastUpdate.year() === 1 ? "n/a" : i.lastUpdate.fromNow() }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <md2-pagination></md2-pagination>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="form-container">
    <router-outlet></router-outlet>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/program-articles/program-articles.component.html